import React from 'react'
import { List } from 'antd'

const Information = (props) => {
  const { entidad } = props

  if (!entidad) {
    return null
  }
  return (
    <>
      <div className='personal-info'>
        <h2>{entidad.name}</h2>
        <h4 className='user-designation m-b-10'>Service</h4>
      </div>

      <div className='contact-info'>
        <div className='m-t-15 m-b-20'>
          <List.Item style={{ padding: '0px 0px' }}>
            <List.Item.Meta title='Language' description={entidad.language} />
          </List.Item>
          <List.Item style={{ padding: '0px 0px' }}>
            <List.Item.Meta title='Description' description={entidad.description} />
          </List.Item>
        </div>
      </div>
    </>
  )
}

Information.defaultProps = {
  entidad: {
    name: ''
  }
}

export default Information
